// AUTO-GENERATO da scripts/genVersion.js — non modificare a mano
export const APP_VERSION = 'v4.15';
